module.exports = __webpack_public_path__ + "img/mobiniti_logo@2x.a9f477e8.png";